import Image from "next/image";
import Link from "next/link";
import { site } from "@/config/site";
import { cn } from "@/lib/utils";

const logoAlt = "Daňové a účetní poradenství, vedení účetnictví Opava";

/**
 * Logo firmy — originální soubor z původního webu
 * (`/images/headers/logo.png` na dane-a-ucetnictvi.eu), uložený v `public/uploads/logo.png`.
 * Zachováváme původní poměr stran (504×137) i barvy; nikdy nenatahujeme ani nepřebarvujeme.
 * Na tmavém podkladu (patička) je logo vložené do světlého panelu, aby zůstalo čitelné.
 */
export function Logo({
  tone = "dark",
  priority = false,
  className,
}: {
  tone?: "dark" | "light";
  priority?: boolean;
  className?: string;
}) {
  const image = (
    <Image
      src="/uploads/logo.png"
      alt={logoAlt}
      width={504}
      height={137}
      priority={priority}
      sizes="(min-width: 640px) 150px, 120px"
      className="h-8 w-auto sm:h-9"
    />
  );

  return (
    <Link
      href="/"
      aria-label={`${site.name} — úvodní stránka`}
      className={cn("inline-flex shrink-0 items-center", className)}
    >
      {tone === "light" ? (
        <span className="inline-flex items-center rounded-lg bg-white px-3 py-2 shadow-soft">
          {image}
        </span>
      ) : (
        image
      )}
    </Link>
  );
}
